<div class="my-3 my-md-5">
    <div class="container-fluid feedbacksection">
        <mat-tab-group class="container-fluid" (selectedTabChange)="tabClick($event)">
            <mat-tab label="IPD">
                <div class="container-fluid px-4 pt-4 card">
                    <mat-accordion class="example-headers-align" multi>
                        <mat-expansion-panel>
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    <i class="fas fa-sliders-h"></i> <span class="pl-2">Filters</span>
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <div class="row mb-4 mt-4">
                                <div class="col-sm-3"><input class="form-control" [(ngModel)]="search" type="text"
                                        placeholder="Search" /></div>

                                <div class="col-sm-3">
                                    <mat-select placeholder="IPD Circle" [(ngModel)]="circle"
                                        (click)="setSearchValue('circle')" multiple>
                                        <input class="mySearchInput" #circleSearch focused="'true'" type="text"
                                            (keyup)="searchOnSelect($event.target.value, 'circle')"
                                            (keydown)="$event.stopPropagation()" autocomplete="off" placeholder="Search"
                                            id="circleSearch">
                                        <mat-option value="{{cir.id}}"
                                            *ngFor="let cir of circles">{{cir.name}}</mat-option>
                                    </mat-select>
                                </div>

                                <div class="col-sm-3">
                                    <mat-select placeholder="Vendor Name" [(ngModel)]="vendor" multiple>
                                        <mat-option value="1">Early Salary</mat-option>
                                        <mat-option value="2">G-Money</mat-option>
                                        <mat-option value="3">Unofin</mat-option>
                                        <mat-option value="4">Shopsy</mat-option>
                                        <mat-option value="5">Credit Fair</mat-option>
                                        <mat-option value="6">Bajaj Finserv EMI</mat-option>
                                        <mat-option value="7">Mahila Money</mat-option>
                                        <mat-option value="8">Liquiloans</mat-option>
                                    </mat-select>
                                </div>

                                <div class="col-sm-3">
                                    <mat-form-field appearance="fill">
                                        <mat-label>Surgery date range</mat-label>
                                        <mat-date-range-input [rangePicker]="picker">
                                            <input matStartDate #dateRangeStart placeholder="Start date">
                                            <input matEndDate #dateRangeEnd placeholder="End date"
                                                (dateChange)="dateRangeChange(dateRangeStart, dateRangeEnd)">
                                        </mat-date-range-input>
                                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                        <mat-date-range-picker #picker></mat-date-range-picker>
                                    </mat-form-field>
                                    <mat-icon class="pointer" (click)="clearDate()">clear</mat-icon>
                                </div>

                                <div class="col-sm-3">
                                    <button type="button" class="btn btn-primary" (click)="loadEmiList(0,perpage,0)">
                                        <i class="fa fa-search" aria-hidden="true"></i> Search Data</button>
                                    <button type="button" class="btn btn-primary ml-1" (click)="resetIpdEmiFilter()"> <i
                                            class="fa fa-sync"></i> Reset Filters</button>
                                </div>
                            </div>
                        </mat-expansion-panel>
                    </mat-accordion>
                    <div class="card">
                        <div class="container-fluid row">
                            <div class="col-sm-6 p-3">
                                <button type="button" class="btn btn-success" [disabled]="loading"
                                    (click)="loadEmiList(0,perpage,0)"><i class="fa fa-sync"
                                        [ngClass]="{'fa-spin':loading}"></i> Refresh List</button>
                                <button *ngIf="myrole=='1'" type="button" class="btn btn-success ml-2"
                                    [disabled]="loading" (click)="exportIpdList()"><i class="fa fa-file-excel"></i>
                                    Export List</button>
                            </div>
                            <div class="col-sm-6"><mat-paginator #paginatorTop [length]="length"
                                    [pageSizeOptions]="pageSizeOptions" [pageSize]="perpage"
                                    (page)="pageEvent = getServerData($event);paginatorBottom.pageIndex = $event.pageIndex"></mat-paginator>
                            </div>
                        </div>
                        <div class="tableFixHead" style="overflow: scroll">
                            <table class="table table-striped">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Patient Name</th>
                                        <th>Mobile</th>
                                        <th>SURGERY DATE</th>
                                        <th>Circle</th>
                                        <th>Treatment</th>
                                        <th>Doctor</th>
                                        <th>Hospital</th>
                                        <th>BILLED AMOUNT</th>
                                        <th>VENDOR NAME</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <ng-container *ngFor="let ipd of ipdList;let index = index;">
                                        <tr data-toggle="collapse" [attr.data-target]="'#collapse-' + index"
                                            [attr.aria-expanded]="false" [attr.aria-controls]="'collapse-' + index">
                                            <td>{{(pageIndex*perpage)+index+1}}</td>
                                            <td>{{ipd.patient}}</td>
                                            <td>{{ipd.phone}}</td>
                                            <td>{{ipd.ipd_surgery_date*1000|date:'d MMM, yyyy'}}</td>
                                            <td>{{ipd.circle_name}}</td>
                                            <td>{{ipd.treatment_name}}</td>
                                            <td>{{ipd.doctor_name}}</td>
                                            <td>{{ipd.hospital_name}}</td>
                                            <td>{{ipd.billed_amt}}</td>
                                            <td>{{ipd.emi_vendor_name}}</td>
                                        </tr>

                                        <tr *ngIf="loading">
                                            <td colspan="20" class="text-center"><i
                                                    class="fa fa-spin fa-spinner fa-2x"></i></td>
                                        </tr>
                                        <tr *ngIf="loaded && !ipdList.length">
                                            <td colspan="20"><i class="far fa-frown"></i> Data not found</td>
                                        </tr>
                                    </ng-container>
                                </tbody>
                            </table>
                        </div>
                        <mat-paginator #paginatorBottom [length]="length" [pageSizeOptions]="pageSizeOptions"
                            [pageSize]="perpage"
                            (page)="pageEvent = getServerData($event);paginatorTop.pageIndex = $event.pageIndex"></mat-paginator>
                    </div>

                </div>
            </mat-tab>
            <mat-tab label="SCAN BOOK">
                <div class="container-fluid px-4 pt-4 card">
                    <mat-accordion class="example-headers-align" multi>
                        <mat-expansion-panel>
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    <i class="fas fa-sliders-h"></i> <span class="pl-2">Filters</span>
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <div class="row mb-4 mt-4">
                                <div class="col-sm-3"><input class="form-control" [(ngModel)]="search" type="text"
                                        placeholder="Search" /></div>

                                <div class="col-sm-3">
                                    <mat-select placeholder="IPD Circle" [(ngModel)]="circle"
                                        (click)="setSearchValue('circle')" multiple>
                                        <input class="mySearchInput" #circleSearch focused="'true'" type="text"
                                            (keyup)="searchOnSelect($event.target.value, 'circle')"
                                            (keydown)="$event.stopPropagation()" autocomplete="off" placeholder="Search"
                                            id="circleSearch">
                                        <mat-option value="{{cir.id}}"
                                            *ngFor="let cir of circles">{{cir.name}}</mat-option>
                                    </mat-select>
                                </div>

                                <div class="col-sm-3">
                                    <mat-form-field appearance="fill">
                                        <mat-label>Scan Done Date</mat-label>
                                        <mat-date-range-input [rangePicker]="picker1">
                                            <input matStartDate #scanDateRangeStart placeholder="Start date">
                                            <input matEndDate #scanDateRangeEnd placeholder="End date"
                                                (dateChange)="scanDateRangeChange(scanDateRangeStart, scanDateRangeEnd)">
                                        </mat-date-range-input>
                                        <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                                        <mat-date-range-picker #picker1></mat-date-range-picker>
                                    </mat-form-field>
                                    <mat-icon class="pointer" (click)="clearScanDate()">clear</mat-icon>
                                </div>

                                <div class="col-sm-3">
                                    <button type="button" class="btn btn-primary" (click)="loadEmiList(0,perpage,1)">
                                        <i class="fa fa-search" aria-hidden="true"></i> Search Data</button>
                                    <button type="button" class="btn btn-primary ml-1" (click)="resetScanEmiFilter()">
                                        <i class="fa fa-sync"></i> Reset Filters</button>
                                </div>
                            </div>
                        </mat-expansion-panel>
                    </mat-accordion>
                    <div class="card">
                        <div class="container-fluid row">
                            <div class="col-sm-6 p-3"><button type="button" class="btn btn-success" [disabled]="loading"
                                    (click)="loadEmiList(0,perpage,1)"><i class="fa fa-sync"
                                        [ngClass]="{'fa-spin':loading}"></i> Refresh List</button>
                                <button *ngIf="myrole=='1'" type="button" class="btn btn-success ml-2"
                                    [disabled]="loading" (click)="exportScanBookList()"><i class="fa fa-file-excel"></i>
                                    Export List</button>
                            </div>
                            <div class="col-sm-6"><mat-paginator #paginatorTop [length]="length"
                                    [pageSizeOptions]="pageSizeOptions" [pageSize]="perpage"
                                    (page)="pageEvent = getServerData($event);paginatorBottom.pageIndex = $event.pageIndex"></mat-paginator>
                            </div>
                        </div>
                        <div class="tableFixHead" style="overflow: scroll">
                            <table class="table table-striped">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Patient Name</th>
                                        <th>Mobile</th>
                                        <th>Scan Done Date</th>
                                        <th>Circle</th>
                                        <th>Treatment</th>
                                        <th>Doctor</th>
                                        <th>Hospital</th>
                                        <th>BILLED AMOUNT</th>
                                        <th>RECEIVED AMOUNT</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <ng-container *ngFor="let ipd of ipdList;let index = index;">
                                        <tr data-toggle="collapse" [attr.data-target]="'#collapse-' + index"
                                            [attr.aria-expanded]="false" [attr.aria-controls]="'collapse-' + index">
                                            <td>{{(pageIndex*perpage)+index+1}}</td>
                                            <td>{{ipd.patient}}</td>
                                            <td>{{ipd.phone}}</td>
                                            <td>{{ipd.scan_done_date*1000|date:'d MMM, yyyy'}}</td>
                                            <td>{{ipd.circle_name}}</td>
                                            <td>{{ipd.treatment_name}}</td>
                                            <td>{{ipd.doctor_name}}</td>
                                            <td>{{ipd.hospital_name}}</td>
                                            <td>{{ipd.billed_amt}}</td>
                                            <td>{{ipd.received_amt}}</td>
                                        </tr>

                                        <tr *ngIf="loading">
                                            <td colspan="20" class="text-center"><i
                                                    class="fa fa-spin fa-spinner fa-2x"></i></td>
                                        </tr>
                                        <tr *ngIf="loaded && !ipdList.length">
                                            <td colspan="20"><i class="far fa-frown"></i> Data not found</td>
                                        </tr>
                                    </ng-container>
                                </tbody>
                            </table>
                        </div>
                        <mat-paginator #paginatorBottom [length]="length" [pageSizeOptions]="pageSizeOptions"
                            [pageSize]="perpage"
                            (page)="pageEvent = getServerData($event);paginatorTop.pageIndex = $event.pageIndex"></mat-paginator>
                    </div>
                </div>
            </mat-tab>
        </mat-tab-group>
    </div>

</div>